import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum CrmOfferPercentageVisibilityTypeId {
  VISIBLE = 'visible',
  HIDDEN = 'hidden',
  NONE = 'none',
}

export class CrmOfferPercentageVisibilityType extends Codebook<CrmOfferPercentageVisibilityTypeId> {
  static readonly VISIBLE = new CrmOfferPercentageVisibilityType(
    CrmOfferPercentageVisibilityTypeId.VISIBLE,
    () => $t('Visible'),
  )
  static readonly HIDDEN = new CrmOfferPercentageVisibilityType(
    CrmOfferPercentageVisibilityTypeId.HIDDEN,
    () => $t('Hidden'),
  )
  static readonly NONE = new CrmOfferPercentageVisibilityType(
    CrmOfferPercentageVisibilityTypeId.NONE,
    () => $t('None'),
  )

  private constructor(
    id: CrmOfferPercentageVisibilityTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
